import { useFetchAnyWorkspacePermissions } from '~/hooks/useFetchAnyWorkspacePermissions';
import { useIsAutomationsUiAvailable } from '~/hooks/useIsAutomationsUiAvailable';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { canManageAutomations } from '~/utils/permissions/workspacePermissions';

/**
 * Automations gates: `automationsEnabled` (LaunchDarkly), workspace `agentSessions` add-on,
 * and `workspace.canManageAutomations` from `Permissions.getFromObjects` in `mode: 'any'`.
 * Viewing and managing both require `canManageAutomations`.
 */
export const useAutomationsAccess = () => {
  const { automationsEnabled } = useTemporaryFeatureFlags();
  const isAutomationsUiAvailable = useIsAutomationsUiAvailable();
  const { data: permissions, isFetched: arePermissionsFetched } = useFetchAnyWorkspacePermissions();

  const canManageAutomationsPermission = arePermissionsFetched && canManageAutomations(permissions);

  const showAutomationsChrome = automationsEnabled && isAutomationsUiAvailable && canManageAutomationsPermission;

  return {
    arePermissionsFetched,
    automationsEnabled,
    canManage: canManageAutomationsPermission,
    isAutomationsUiAvailable,
    showAutomationsChrome,
  };
};
